import { render, staticRenderFns } from "./FolderRow.vue?vue&type=template&id=0522c5a4"
import script from "./FolderRow.vue?vue&type=script&lang=js"
export * from "./FolderRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports